export default class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            const buttonType = this.getAttribute('data-button');
            const buttonTypeFromBreakpoint = buttonType ? parseInt(buttonType.split(':')[1]) : null;
            const announcementBar = document.querySelector('.js-announcement-bar');

            if (announcementBar) {
                document.body.style.setProperty('--announcement-bar-offset', `${(announcementBar.getBoundingClientRect().height - window.scrollY) / 16}rem`);
            }
            
            // If button has a type of 'toggle' then add is-active class.
            // Append `toggle` value with breakpoint value, e.g `toggle:1280` to only apply from a specific breakpoint.

            if (modal && buttonType?.includes('toggle') && !button.classList.contains('is-active')) {
                if (window.innerWidth >= buttonTypeFromBreakpoint || isNaN(buttonTypeFromBreakpoint)) {
                    button.classList.add('is-active');
                }
                modal.show(button);
            } else if (modal && buttonType?.includes('toggle') && button.classList.contains('is-active')) {
                if (window.innerWidth >= buttonTypeFromBreakpoint || isNaN(buttonTypeFromBreakpoint)) {
                    button.classList.remove('is-active');
                }
                modal.hide();
            } else {
                modal.show(button);
            }
        });

        document.addEventListener('keyup', event => {
            if (event.key === 'Escape') {
                button.classList.remove('is-active');
            }
        });
    }
}

customElements.define('modal-opener', ModalOpener);
